import { render, staticRenderFns } from "./Detail_Personal.vue?vue&type=template&id=caf8ebfe&scoped=true"
import script from "./Detail_Personal.vue?vue&type=script&lang=js"
export * from "./Detail_Personal.vue?vue&type=script&lang=js"
import style0 from "./Detail_Personal.vue?vue&type=style&index=0&id=caf8ebfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf8ebfe",
  null
  
)

export default component.exports